import Arrow from "../SVG/ArrowSvg";
import Underline from "../SVG/Underline";
import "./newsletter.scss";

const NewsLetter = () => {
  return (
    <section className="newsletter">
      <div className="text-container">
        <p className="tag">Nieuwsbrief</p>
        <div className="title">
          Mis &nbsp;
          <span className="relative">
            niks!
            <div className="underline">
              <Underline />
            </div>
          </span>
        </div>
        <p className="sub-text">
          Maak je leven gemakkelijker: schrijf je in voor mijn nieuwsbrief vol
          praktische tips en inspiratie.
        </p>
      </div>
      <div className="input-container">
        <i className="icon">
          <Arrow />
        </i>
        <input className="input-field" type="text" placeholder="Email" />
        <p className="input-text">Inspiratie in je inbox"</p>
      </div>
    </section>
  );
};

export default NewsLetter;
